import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'index',
		component: () => import('@/pages/index.vue'),
		meta: {
			title: '首页'
		}
	},
  {
  	path: '/gjwm',
  	name: 'gjwm',
  	component: () => import('@/pages/gjwm/gjwm.vue'),
  	meta: {
  		title: '关于我们'
  	}
  },
  {
  	path: '/cybj',
  	name: 'cybj',
  	component: () => import('@/pages/cybj/cybj.vue'),
  	meta: {
  		title: '产业布局'
  	}
  },
  {
  	path: '/jscx',
  	name: 'jscx',
  	component: () => import('@/pages/jscx/jscx.vue'),
  	meta: {
  		title: '技术创新'
  	}
  },
  {
  	path: '/xwzx',
  	name: 'xwzx',
  	component: () => import('@/pages/xwzx/xwzx.vue'),
  	meta: {
  		title: '新闻资讯'
  	}
  },
  {
  	path: '/rcyj',
  	name: 'rcyj',
  	component: () => import('@/pages/rcyj/rcyj.vue'),
  	meta: {
  		title: '人才引进'
  	}
  },
  {
  	path: '/lxwm',
  	name: 'lxwm',
  	component: () => import('@/pages/lxwm/lxwm.vue'),
  	meta: {
  		title: '联系我们'
  	}
  }
]

const router = new VueRouter({
	mode: 'history',
	routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js